import * as logger from 'loglevel';

/**
 * This function returns all airports from the everymundo API
 *
 * @param {*} self It is the instance of the calendar
 * type: By default, the airports of origin are requested.
 * When type = destination then all the airports that can be
 * reached from the current airport selected at origin are
 * returned from the API
 */
const promiseCities = (self) =>
  new Promise((resolve, reject) => {
    const { getCities, prePopulation, integrationSettings, meta, pageContext } = self.props;

    if (typeof getCities !== 'function') {
      const MESSAGE = `PROMISE__CITIES: **getCities** must be function.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    } else {
      getCities(
        Object.assign({}, prePopulation.airport, {
          airlineIataCode: prePopulation.airlineIataCode,
          language: prePopulation.languageCode,
          routeOption: { airportType: 'ORIGIN' }
        }),
        integrationSettings,
        meta,
        pageContext
      )
        .then((response) => {
          let airportsFromApi = [];
          if (Array.isArray(response)) {
            airportsFromApi = response;
          }
          resolve(airportsFromApi);
        })
        .catch((err) => {
          logger.error(err.message);
          reject(err);
        });
    }
  });

/**
 * This promise returns all fares
 * for an airport origin and destination airport
 *
 * @param {*} self
 * self Is the instance of the calendar
 */
const offersPromise = (self) =>
  new Promise((resolve, reject) => {
    const {
      getOffers,
      integrationSettings,
      meta,
      pageContext,
      prePopulation: { itemCount, languageCode, currency }
    } = self.props;
    const { budget, dateRange, origin, homeType, guests } = self.state;
    const filter = {
      origin,
      budget,
      guests,
      dateRange,
      homeType,
      languageCode,
      currency,
      itemCount
    };
    if (typeof getOffers !== 'function') {
      const MESSAGE = `PROMISE__FARES: **getOffers** must be function.`;
      logger.error(MESSAGE);
      self.setState({ isLoadingOffers: false });
      reject(MESSAGE);
    } else {
      getOffers(filter, integrationSettings, meta, pageContext)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    }
  });

/**
 * This function prepares the conditions mount the component
 * It makes the calls to the API to start the reatured container
 * with the fares and the airport of origin
 *
 * @param {*} self
 * self Is the instance of the calendar
 */
const hookComponentDidMount = (self) => {
  const { showFilters } = self.props;
  if (showFilters) {
    Promise.all([offersPromise(self), promiseCities(self)])
      .then(([data, departureAirports]) => {
        self.setState({
          departureAirports,
          offers: data,
          isLoadingOffers: false,
          errorLoading: false,
          isSkeletonShown: false,
          isLoadingDepartureAirports: false
        });
      })
      .catch(() => {
        self.setState({
          isLoadingOffers: false,
          errorLoading: true,
          isSkeletonShown: false,
          isLoadingDepartureAirports: false
        });
      });
  } else {
    offersPromise(self)
      .then((data) => {
        self.setState({
          offers: data,
          isLoadingOffers: false,
          errorLoading: false,
          isSkeletonShown: false
        });
      })
      .catch(() => {
        self.setState({
          isLoadingOffers: false,
          errorLoading: true,
          isSkeletonShown: false
        });
      });
  }
};

/**
 * This function prepares the conditions mount the component
 * It makes the calls to the API to start the reatured container
 * with the fares and the airport of origin
 *
 * @param {*} self
 * self Is the instance of the calendar
 */
const hookOnErrorAlert = (self) => {
  const { showFilters } = self.props;

  self.setState({ isLoadingOffers: true, isLoadingDepartureAirports: true }, () => {
    if (showFilters) {
      Promise.all([offersPromise(self), promiseCities(self)])
        .then(([data, departureAirports]) => {
          self.setState({
            departureAirports,
            offers: data,
            isLoadingOffers: false,
            errorLoading: false,
            isLoadingDepartureAirports: false
          });
        })
        .catch(() => {
          self.setState({
            isLoadingOffers: false,
            errorLoading: true,
            isLoadingDepartureAirports: false
          });
        });
    } else {
      offersPromise(self)
        .then((data) => {
          self.setState({
            offers: data,
            isLoadingOffers: false,
            errorLoading: false
          });
        })
        .catch(() => {
          self.setState({
            isLoadingOffers: false,
            errorLoading: true,
            isLoadingDepartureAirports: false
          });
        });
    }
  });
};

/**
 * This function prepares obtain fares when airport is cahnged
 * It makes the calls to the API to start the reatured container
 * with the fares and the airport of origin
 *
 * @param {*} self
 * self Is the instance of the calendar
 */
const hookFaresOnFilterChange = (self) => {
  self.setState({ isLoadingOffers: true }, () => {
    offersPromise(self)
      .then((data) => {
        self.setState({
          offers: data,
          isLoadingOffers: false,
          errorLoading: false
        });
      })
      .catch(() => {
        self.setState({
          isLoadingOffers: false,
          errorLoading: true
        });
      });
  });
};

export { hookComponentDidMount, hookFaresOnFilterChange, hookOnErrorAlert };
